export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Максимальная высота
  //--------------------------------------------------------------------------
  maxHeight: {
    type: Number,
    default: 460,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});